class HscPipelineColumns {
    status;
    properties;
    loanAmount;
    totalGrossFee;
    referral;
    credits;
    hscFee;
    url;

    constructor({data, key, transactionYear}) {
        switch (key) {
            case 'COURTING':
                this.status = 'Courting';
                break;
            case 'LOAN':
                this.status = 'Loan In Process';
                break;
            case 'CLOSED_YTD':
                this.status = 'Closed YTD';
                this.url = 'closed-ytd';
                break;
            case 'CLOSED_SBO':
                this.status = `Closed - ${transactionYear - 1}`;
                this.url = `closed-${transactionYear - 1}`;
                break;
            case 'CLOSED_SBT':
                this.status = `Closed - ${transactionYear - 2}`;
                this.url = `closed-${transactionYear - 2}`;
                break;
        }
        this.properties = data && data[`${key}_PROPERTIES`] ? data[`${key}_PROPERTIES`] : 0;
        this.loanAmount = data && data[`${key}_LOAN_AMOUNT`] ? data[`${key}_LOAN_AMOUNT`] : 0;
        this.totalGrossFee = data && data[`${key}_GROSS_FEE`] ? data[`${key}_GROSS_FEE`] : 0;
        this.referral = data && data[`${key}_REFERRAL`] ? data[`${key}_REFERRAL`] : 0;
        this.credits = data && data[`${key}_CREDITS`] ? data[`${key}_CREDITS`] : 0;
        this.hscFee = data && data[`${key}_HSC_FEE`] ? data[`${key}_HSC_FEE`] : 0;
    }
}

export class HscPipelineModel {
    courting;
    loanInProcess;
    closedYTD;
    closedSBO;
    closedSBT;

    constructor(data) {
        const transactionYear = new Date().getFullYear();
        this.courting = new HscPipelineColumns({data, key: 'COURTING'});
        this.loanInProcess = new HscPipelineColumns({data, key: 'LOAN'});
        this.closedYTD = new HscPipelineColumns({data, key: 'CLOSED_YTD'});
        this.closedSBO = new HscPipelineColumns({data, key: 'CLOSED_SBO', transactionYear});
        this.closedSBT = new HscPipelineColumns({data, key: 'CLOSED_SBT', transactionYear});
    }
}